// Shared business logic for web and mobile frontends
// Export hooks, utilities, API clients, and state management here

export const APP_NAME = 'Langmail'

// Language constants
// biome-ignore lint/performance/noBarrelFile: package entry point requires re-exports
export { languageOptions, SUPPORTED_LANGUAGES } from './constants/language'
// Auth
export { AuthContext, type StandaloneSignupInput, useAuth } from './features/auth/use-auth'
// Icons
export { Google } from './icons'
// Contact utilities
export { getContactDisplayName, getTldFromSender } from './utils/contact-utils'
// Query keys
export { queryKeys } from './utils/query-keys'
// Text utilities
export { formatTimestamp, truncateMessage } from './utils/text-utils'
// tRPC utilities
export { TRPCProvider, useTRPC, useTRPCClient } from './utils/trpc'
